import { render, staticRenderFns } from "./FormPlanoTrabalho.vue?vue&type=template&id=4c3043d6&"
import script from "./FormPlanoTrabalho.vue?vue&type=script&lang=js&"
export * from "./FormPlanoTrabalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports